import React, { useState } from 'react';
import { Layout, Typography, Row, Col, Space, Divider, Button, Modal } from 'antd';
import {
  PhoneOutlined,
  MailOutlined,
  WechatOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';

const { Footer } = Layout;
const { Title, Text } = Typography;

const PublicFooter = () => {
  const [contactModalVisible, setContactModalVisible] = useState(false);

  return (
    <Footer style={{ textAlign: 'center', background: '#001529', color: 'white', padding: '48px 24px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* 联系信息和微信二维码 */}
        <Row gutter={[48, 32]} style={{ marginBottom: '32px' }}>
          <Col xs={24} md={8}>
            <div style={{ textAlign: 'center' }}>
              <Title level={4} style={{ color: 'white', marginBottom: '16px' }}>
                <PhoneOutlined style={{ marginRight: '8px' }} />
                联系我们
              </Title>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Text style={{ color: 'rgba(255,255,255,0.85)' }}>
                  <PhoneOutlined style={{ marginRight: '8px' }} />
                  技术支持：17820345350
                </Text>
                <Text style={{ color: 'rgba(255,255,255,0.85)' }}>
                  <MailOutlined style={{ marginRight: '8px' }} />
                  邮箱：284516383@qq.com
                </Text>
                <div style={{ marginTop: '12px' }}>
                  <Text style={{ color: 'rgba(255,255,255,0.85)', display: 'block', marginBottom: '8px' }}>
                    <WechatOutlined style={{ marginRight: '8px' }} />
                    微信客服：扫码添加客服微信
                  </Text>
                  <img
                    src={`${process.env.PUBLIC_URL}/wechat+.jpg`}
                    alt="微信客服二维码"
                    style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'contain',
                      borderRadius: '8px',
                      border: '2px solid rgba(255,255,255,0.2)'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                  <div style={{ marginTop: '12px' }}>
                    <Button
                      type="primary"
                      size="small"
                      icon={<WechatOutlined />}
                      onClick={() => setContactModalVisible(true)}
                      style={{
                        background: '#07c160',
                        borderColor: '#07c160',
                        fontSize: '12px',
                        height: '28px',
                        padding: '0 12px'
                      }}
                    >
                      联系客服
                    </Button>
                  </div>
                </div>
              </Space>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div style={{ textAlign: 'center' }}>
              <Title level={4} style={{ color: 'white', marginBottom: '16px' }}>
                <WechatOutlined style={{ marginRight: '8px' }} />
                微信小程序
              </Title>
              <div style={{ marginBottom: '16px' }}>
                <img
                  src={`${process.env.PUBLIC_URL}/wechatlogo.jpg`}
                  alt="微信小程序码"
                  style={{
                    width: '120px',
                    height: '120px',
                    objectFit: 'contain',
                    borderRadius: '8px',
                    border: '2px solid rgba(255,255,255,0.2)'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: '14px' }}>
                扫码体验小程序
              </Text>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div style={{ textAlign: 'center' }}>
              <Title level={4} style={{ color: 'white', marginBottom: '16px' }}>
                <SafetyCertificateOutlined style={{ marginRight: '8px' }} />
                产品信息
              </Title>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Text style={{ color: 'rgba(255,255,255,0.85)' }}>
                  教室小喇叭 v1.0
                </Text>
                <Text style={{ color: 'rgba(255,255,255,0.85)' }}>
                  校园班级广播与家校协同平台
                </Text>
                <Text style={{ color: 'rgba(255,255,255,0.85)' }}>
                  官方网站：www.810086.com
                </Text>
              </Space>
            </div>
          </Col>
        </Row>

        <Divider style={{ borderColor: '#434343' }} />

        {/* 版权信息和备案信息 */}
        <div style={{ marginBottom: '16px' }}>
          <Text style={{ color: 'rgba(255,255,255,0.65)' }}>
            教室小喇叭 ©2026 - 校园班级广播与家校协同平台
          </Text>
        </div>

        {/* 工信部备案信息 */}
        <div>
          <Text style={{ color: 'rgba(255,255,255,0.65)', fontSize: '14px' }}>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'rgba(255,255,255,0.65)', textDecoration: 'none' }}
            >
              粤ICP备2025398217号
            </a>
            <span style={{ margin: '0 10px' }}>|</span>
            <a
              href="/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'rgba(255,255,255,0.65)', textDecoration: 'none' }}
            >
              隐私政策
            </a>
          </Text>
        </div>
      </div>

      {/* 联系客服模态框 */}
      <Modal
        title="联系客服"
        open={contactModalVisible}
        onCancel={() => setContactModalVisible(false)}
        footer={null}
        width={400}
        centered
      >
        <div style={{ textAlign: 'center', padding: '24px' }}>
          <img
            src={`${process.env.PUBLIC_URL}/wechat+.jpg`}
            alt="微信客服二维码"
            style={{
              width: '250px',
              height: '250px',
              objectFit: 'contain',
              borderRadius: '8px',
              border: '2px solid #f0f0f0'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <div style={{ marginTop: '24px' }}>
            <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '8px' }}>
              扫码添加客服微信
            </Text>
            <Text type="secondary" style={{ fontSize: '14px' }}>
              工作日 9:00-18:00 在线服务
            </Text>
            <div style={{ marginTop: '16px' }}>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                技术支持：17820345350
              </Text>
              <br />
              <Text type="secondary" style={{ fontSize: '12px' }}>
                邮箱：284516383@qq.com
              </Text>
            </div>
          </div>
        </div>
      </Modal>
    </Footer>
  );
};

export default PublicFooter;
